// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { TvColDefVisEnum } from './TvColumnDefaultVisibilityEnum';
export class TvBaseColumns {
    constructor() {
        this.defaultalignment = 'right';
    }
    createColumnItem(locKey, id, formatter = "fixed" /* StandardFormatterName.Fixed */, highlightDiff = false, customdatafields = undefined, hideByDefault = false) {
        if (Resources.isHidden(locKey))
            return null;
        const df = isNullOrUndefined(customdatafields) ? [id] : customdatafields;
        const name = Resources.getResource(locKey);
        const toolTipKey = `${locKey}.descr`;
        const toolTip = Resources.IsResourcePresent(toolTipKey)
            ? Resources.getResource(`${locKey}.descr`)
            : name;
        const columnItem = {
            label: name,
            alignment: this.defaultalignment,
            id,
            dataFields: df,
            notSortable: true,
            formatter,
            tooltipProperty: toolTip,
            help: toolTip,
            highlightDiff,
            hideByDefault
        };
        if (highlightDiff) {
            columnItem.highlightDiff = true;
        }
        return columnItem;
    }
    createAccSummaryColumnItem(locKey, id, formatter, defVisibility) {
        const hideByDefault = defVisibility === TvColDefVisEnum.Hidden;
        return this.createColumnItem(locKey, id, formatter, false, undefined, hideByDefault);
    }
}
